import ProductImage from '@shared/svelte/Components/ProductImage.svelte'

var ctrl = function($scope, $http, Flash, C, $state) {
  $scope.imageForm = $scope.form || {};
  $scope.loading = false;
  $scope.ProductImage = ProductImage;
  $scope.isRemovable = ($scope.entityType === 'ProductLine' || $scope.entityType === 'Distributor')
                        && $scope.obj.image_upload_id;

  if (!$scope.obj) { return; }

  $scope.imageUpload = {
    entity_id: $scope.obj.id,
    entity_type: $scope.entityType
  };

  $scope.uploadFile = function(event) {
    $scope.imageUpload.file_data = event.target.files[0];
    $scope.imageForm.$setDirty();
    $scope.$root.safeApply();
  };

  $scope.$watch('imageUpload.image_url', function() {
    $scope.obj.image_url = $scope.imageUpload.image_url;
  });

  var postSave = function(res) {
    $scope.loading = false;
    Flash.setMessage('Image saved!', true, 'notice');

    if ($scope.obj && res.data.entity) {
      $scope.obj = _.extend($scope.obj, {image_name: res.data.entity.image_name,
                                         image_version: res.data.entity.image_version,
                                         override_image: res.data.entity.override_image,
                                         discount_override_image: res.data.entity.discount_override_image,
                                         cloudinary_image_url: res.data.cloudinary_image_url});

      $scope.imageUpload.image_url = null;
      $scope.$root.safeApply();
    }
    if ($scope.cb) { $scope.cb({res: $scope.newObj, newRes: $scope.obj}); }
    if ($scope.reloadOnSave) { $state.reload(); }
  }

  var saveWithFile = function() {
    $scope.loading = true;

    if (!$scope.imageUpload.image_url && !$scope.imageUpload.file_data) {
      if ($scope.cb) { $scope.cb({res: $scope.newObj, newRes: $scope.newObj}); }
      return $scope.loading = false;
    }
    var formData = new FormData();
    if ($scope.imageUpload.file_data) {
      formData.append('image_upload[file]', $scope.imageUpload.file_data);
    }
    formData.append('image_upload[entity_id]', $scope.imageUpload.entity_id);
    formData.append('image_upload[entity_type]', $scope.imageUpload.entity_type);
    if ($scope.imageUpload.image_url) {
      formData.append('image_upload[image_url]', $scope.imageUpload.image_url);
    }

    $http({
      method: 'POST',
      url: `/api/${C.APP_NAME}/image_uploads`,
      headers: {
        'Content-Type': undefined
      },
      data: formData
    }).then(function success(res) {
      $scope.loading = false;
      $scope.$broadcast('clear-input');
      $scope.imageUpload.image_url = res.data.download_url
      $scope.imageUpload.file_data = null;
      postSave(res);
    }, function error(res) {
      $scope.loading = false;
      $scope.errors = res.data;
      if ($scope.cb) { $scope.cb({res: $scope.newObj, newRes: $scope.obj}); }
    })
  }

  $scope.save = function(event, obj, cb) {
    if (_.get(obj, 'data.id') && !$scope.imageUpload.entity_id) {
      $scope.imageUpload.entity_id = obj.data.id;
    }
    $scope.cb = cb;
    $scope.newObj = obj;

    return saveWithFile();
  };

  $scope.removeImage = function() {
    if (!$scope.obj.image_upload_id) { return; }
    $scope.loading = true;
    $http({
      method: 'POST',
      url: `/api/${C.APP_NAME}/image_uploads/${$scope.obj.image_upload_id}/remove_image_reference`,
      data: {
        image_upload: {...$scope.obj, entity_id: $scope.obj.id,
          entity_type: $scope.entityType},
      }
    }).then(function success(res) {
      $scope.loading = false;
      if ($scope.cb) { $scope.cb({res: $scope.newObj, newRes: $scope.obj}); }
      $scope.reloadOnSave = true;
      postSave(res);
    }, function error(res) {
      console.error(res);
      $scope.errors = res.data;
    })
  }

  if (!$scope.handleSave) {
    $scope.$on('image-upload-save', $scope.save)
  }
};

ctrl.$inject = ['$scope', '$http', 'Flash', 'C', '$state'];

var directive = function() {
  return {
    scope: {
      obj: '=',
      entityType: '@',
      handleSave: '=',
      showHeader: '=',
      form: '=?',
      reloadOnSave: '=?'
    },
    controller: ctrl,
    templateUrl: require('../../templates/images/image_upload_widget.html')
  };
};

tiz.directive('imageUploadWidget', directive);
